// extracted by mini-css-extract-plugin
module.exports = {"themeColor":"#3f4e5a","main":"MainLayout-module--main--1kVLb","container":"MainLayout-module--container--2_b4z","skipToMain":"MainLayout-module--skipToMain--2gSon"};